import util from './util';
import axios from './../axios';
const apiPath = 'api/admin/care-rooms';

const careRoomApi = {
    index: query => {
        return axios.get(
            `${
                process.env.VUE_APP_API_ENDPOINT
            }/${apiPath}/index?${util.queryToString(query)}`
        );
    },
    createRoom: entity => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/create-room`,
            {
                ...entity
            }
        );
    }
};

export default careRoomApi;
